import { useCallback, useEffect, useState } from 'react'
import GrileService from '../../../../services/grile-service'

const usePreviewSubject = subject => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [height, setHeight] = useState(0)
  const [allTags, setAllTags] = useState([])
  const [hints, setHints] = useState('')
  const [checkbox, setCheckbox] = useState([false, false, false, false])
  const [allowHint, setAllowHint] = useState(true)
  const handleNextGrid = () => {
    setCurrentIndex(prev => prev + 1)
  }
  const handlePrevGrid = () => {
    setCurrentIndex(prev => prev - 1)
  }

  const handleCurrentGrid = useCallback(index => {
    setCurrentIndex(index)
  }, [])

  const handleUserGetHint = useCallback(
    async grilaId => {
      try {
        const response = await GrileService.getHint(grilaId)

        setHints(prevHints => {
          const newHints = [...prevHints]
          newHints[currentIndex] = response?.content || 'Nu exista hint'
          return newHints
        })
      } catch (error) {
        console.error('Error fetching hint:', error)
      }
    },
    [currentIndex],
  )
  const handleGetHint = useCallback(async () => {
    await handleUserGetHint(subject?.[currentIndex]?.id)
  }, [subject, currentIndex, handleUserGetHint])

  useEffect(() => {
    const fetcher = async () => {
      try {
        const response = await GrileService.getAllFilters()
        setAllTags(response?.filters)
      } catch (error) {
        console.error(error)
      }
    }
    fetcher()
  }, [])

  return {
    currentIndex,
    handleNextGrid,
    handlePrevGrid,
    handleCurrentGrid,
    setHeight,
    height,
    allTags,
    handleGetHint,
    hints,
    checkbox,
    setCheckbox,
    allowHint,
    setAllowHint,
  }
}

export default usePreviewSubject
